import {
    useInfiniteQuery,
    type InfiniteData,
    type QueryKey,
    type UseInfiniteQueryResult,
} from '@tanstack/react-query'
import { PaginatedUploadManagerResponse } from '../components/Applications/UploadManager/interface'
import { fetchUploadManagerData } from '../services/uploadManagerService'
import { MRT_ColumnFiltersState } from 'material-react-table'

export const useUploadManager = (
    orgId: string | undefined,
    sortBy: string,
    sortOrder: 'ASC' | 'DESC',
    searchBy?: string,
    searchQuery?: string,
    filters?: MRT_ColumnFiltersState,
): UseInfiniteQueryResult<
    InfiniteData<PaginatedUploadManagerResponse>,
    Error
> => {
    return useInfiniteQuery<
        PaginatedUploadManagerResponse,
        Error,
        InfiniteData<PaginatedUploadManagerResponse>,
        QueryKey,
        number
    >({
        queryKey: [
            'upload-manager',
            orgId,
            sortBy,
            sortOrder,
            searchBy,
            searchQuery,
            filters,
        ],
        queryFn: ({ pageParam = 0 }) =>
            fetchUploadManagerData(
                orgId ?? '',
                pageParam,
                20,
                sortBy,
                sortOrder,
                searchBy,
                searchQuery,
                filters,
            ),
        getNextPageParam: (lastPage) => {
            return lastPage.last ? undefined : lastPage.number + 1
        },
        initialPageParam: 0,
        enabled: !!orgId,
        refetchInterval: 20000,
    })
}
